import { z } from "zod";
import { ImageMediaSchema } from "../Media";
import { CharacterRoleSchema } from "../CharacterRole";
import { RichTextSchema } from "../RichText";
export const CharacterSchema = z.object({
    media: ImageMediaSchema,
    name: z.string(),
    role: CharacterRoleSchema,
});
export const CharacterChangeSchema = z.object({
    title: z.string(),
    icon: ImageMediaSchema.optional(),
    description: RichTextSchema,
});
export const CharacterChangesSchema = z.object({
    character: CharacterSchema,
    summary: RichTextSchema,
    changes: z.array(CharacterChangeSchema),
});
//# sourceMappingURL=index.js.map